import { isNil, memoize } from "lodash";
import { usePastDaysLimit } from "PFApp/hooks";
import { useCallback } from "react";

import { addDays, setTimeToMidnight } from "../calendar.utils";
import { HoverPeriodData } from "./row";

const checkIsPeriodAllowedToCreateBooking = memoize(
  (period: HoverPeriodData["period"], pastDaysLimit: number = 0): boolean => {
    const currentDate = new Date();
    const earliestAllowedDate =
      !isNil(pastDaysLimit) && pastDaysLimit > 0
        ? setTimeToMidnight(addDays(currentDate, -1 * pastDaysLimit))
        : currentDate;
    if ("date" in period) {
      const { date } = period;
      return date && earliestAllowedDate.getTime() <= date.getTime();
    } else {
      const { startDate } = period;
      return startDate && earliestAllowedDate.getTime() <= startDate.getTime();
    }
  }
);

type UsePeriodAllowedToCreateBookingCheckerReturn = (period: HoverPeriodData["period"]) => boolean;
export const usePeriodAllowedToCreateBookingChecker = (): UsePeriodAllowedToCreateBookingCheckerReturn => {
  const pastDaysLimit = usePastDaysLimit();

  return useCallback(
    (period: HoverPeriodData["period"]) => checkIsPeriodAllowedToCreateBooking(period, pastDaysLimit),
    [pastDaysLimit]
  );
};
